import { render, staticRenderFns } from "./ANA005-AdmNorma.vue?vue&type=template&id=792a1977&"
import script from "./ANA005-AdmNorma.vue?vue&type=script&lang=js&"
export * from "./ANA005-AdmNorma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports